import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  GelBoxLayout,
  GelContainerLite,
  GelLabel
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import { API } from "../constants/constants";
import { GET_SUCCESSPAGE_CONTENT_QUERY } from "../graphql/graphql-contentful";

const SuccessPage = () => {
  const { global: { themeColorGrayT05, sizeBaseUnit, sizeBaseX15, themeColorWhite, borderSizeSm, themeColorGrayT20, themeColorBackgroundSuccess } } = getGelTokens()

  const { state } = useLocation();
  const [contentfulData, setcontenfulData] = useState<null | {
    mmcTfnPageCollection: any;
  }>(null);

  const origin = sessionStorage.getItem("origin") ?? "";

  useEffect(() => {
    if (!state) {
      sessionStorage.removeItem("origin");
      console.log(atob(origin));

      if (atob(origin).indexOf("?source=") > 0) {
        window.location.replace(atob(origin));
      } else {
        sessionStorage.removeItem("origin");
        window.location.replace(atob(origin) + "?source=TFN");
      }
    }

    //contentful call
    axios
      .post(API.CONTENTFUL_URL, {
        query: GET_SUCCESSPAGE_CONTENT_QUERY,
      })
      .then(async (response) => {
        setcontenfulData(response.data?.data);
      });

    setTimeout(() => {
      sessionStorage.removeItem("origin");

      if (atob(origin).indexOf("?source=") > 0) {
        window.location.replace(atob(origin));
      } else {
        sessionStorage.removeItem("origin");
        window.location.replace(atob(origin) + "?source=TFN");
      }
    }, 5000);
  }, []);
  return (
    <div
      style={{
        backgroundColor: themeColorGrayT05,
        paddingBottom: "100px",
      }}
    >
      <Header
        title={contentfulData?.mmcTfnPageCollection.items[0]?.successPageTitle}
      />
      <GelContainerLite>
        <GelBoxLayout
          gap="medium"
          alignment="center"
          space="auto"
          distribution="spaceBetween"
          vertical="true"
          padding="large"
          margin="large"
          style={{
            marginTop: `-${sizeBaseX15}px`,
            backgroundColor: themeColorWhite,
            border: `${borderSizeSm}px solid`,
            borderColor: themeColorGrayT20,
          }}
        >
          <FontAwesomeIcon
            icon={faCheckCircle}
            style={{
              fontSize: `${sizeBaseUnit}em`,
              color: themeColorBackgroundSuccess,
            }}
          />
          <GelLabel large>
            {contentfulData?.mmcTfnPageCollection.items[0]?.successPageText1}
          </GelLabel>
          <GelLabel large>
            {contentfulData?.mmcTfnPageCollection.items[0]?.successPageText2}
          </GelLabel>
        </GelBoxLayout>
      </GelContainerLite>
      <Footer />
    </div>
  );
};

export default SuccessPage;
